'use client';

import { createContext, useContext } from 'react';

export const LaunchDarklyDisabledContext = createContext(false);

/**
 * True only when LaunchDarklyProvider deliberately skipped mounting the SDK in local dev with no client-side ID.
 * Consumers waiting on useLDClient must not block.
 */
export function useIsLaunchDarklyDisabled() {
  return useContext(LaunchDarklyDisabledContext);
}
